import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaCarouselPrimaryTextModel extends BaseModel {
  variables?: { [key: string]: string } | MetaCarouselPrimaryTextVariables;
}

export interface MetaCarouselPrimaryTextVariables {
  PrimaryText: string;
}

export class MetaCarouselPrimaryTextInitVariables implements MetaCarouselPrimaryTextVariables {
  PrimaryText = '';
}

export class MetaCarouselPrimaryTextInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaCarouselPrimaryTextInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
